module.exports = __webpack_public_path__ + "static/media/IDEA_F1.88df8c64.txt";